import { Header } from 'components/molecules';
import { CreateUserTemplate } from 'components/templates';
import { withAuth } from 'HOCs';

const breadcrumbs = [{ label: 'Administración' }];

const CreateBotPage = () => {
  return (
    <>
      <Header
        title="Usuarios"
        subtitle="Crea un usuario"
        breadCrumbsProps={{ breadcrumbs: breadcrumbs }}
      />
      <CreateUserTemplate />
    </>
  );
};

export default withAuth(CreateBotPage, undefined, 'mayasoft');
